import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useAccount } from "@redux/account";
import { DefaultItem } from "@assets/papers";
import { DefaultLabel } from "@assets/label";
import { OutlinedInputDefault } from "@assets/TextField";
import { useInput } from "@assets/hooks";
import { maxLengthCheck } from "@assets/validators";
import AdvertiserComplete from "@modals/AdvertiserDialog/AdvertiserComplete";
import { emailRule } from "@assets/utils/check";
import { useMenuDispatch } from "@assets/contexts/MenuContext";

const CompAdvertiserAdd = () => {
  const value = useMenuDispatch(); // function  context
  const account = useAccount();
  const navigate = useNavigate();
  const name = useInput("", (value) => maxLengthCheck(20, value)); // 광고주/ 대행사
  const email = useInput(""); // 담당 이메일
  const userId = useInput("", (value) => maxLengthCheck(20, value)); // 아이디
  const userPw = useInput("", (value) => maxLengthCheck(20, value)); // 비밀번호
  const userPwConfirm = useInput("", (value) => maxLengthCheck(20, value)); // 비밀번호 확인
  const [open, setOpen] = useState(false);

  const handleAdd = () => {
    if (name.value === "" || !name.value) {
      alert("광고주/대행사를 확인해주세요.");
      return false;
    }
    if (email.value.match(emailRule) === null) {
      alert("담당 이메일을 확인해주세요");
      return false;
    }

    if (userId.value === "" || !userId.value) {
      alert("아이디를 확인해주세요.");
      return false;
    }

    if (userPw.value === "" || !userPw.value) {
      alert("비밀번호를 확인해주세요.");
      return false;
    }
    if (userPwConfirm.value === "" || !userPwConfirm.value) {
      alert("비밀번호 확인을 확인해주세요.");
      return false;
    }
    if (userPwConfirm.value !== userPw.value) {
      alert("비밀번호가 같지 않습니다.");
      return false;
    }
    const totalData = {
      id: userId.value,
      pw: userPw.value,
      name: name.value,
      email: email.value,
      permission: ["AD"],
    };
    value({ type: "loadingStart" });
    account.signup(totalData, (data, response) => {
      if (response.status === 200) {
        if (data.result.url === null) {
          alert("데이터 정보가 없습니다.");
        } else {
          setOpen(true);
        }
        value({ type: "loadingEnd" });
      } else {
        if (!response.data || !response.data.error) {
          alert("에러가 발생하였습니다.");
        } else {
          alert(response.data.error.message);
        }
        value({ type: "loadingEnd" });
      }
    });
  };
  const handleCofirm = () => {
    navigate("/ad", { replace: true });
  };
  return (
    <>
      <Grid container justifyContent="center" direction="column">
        <Container maxWidth="lg" sx={{ pt: 7.75 }}>
          <Grid container justifyContent="center">
            <DefaultItem sx={{ boxShadow: 0, height: "100%", width: 630 }}>
              <Grid
                container
                direction="column"
                sx={{ pt: 8.75, pl: 7.5, pr: 7.5 }}
              >
                <Typography
                  variant="h2"
                  fontWeight={500}
                  color={"grey.900"}
                  align="left"
                >
                  등록할 광고주 정보를
                  <br />
                  작성해 주세요.
                </Typography>
                <Grid container>
                  <Grid container sx={{ mb: 3, mt: 3 }}>
                    <Grid sx={{ width: "50%", pr: 1.25 }}>
                      <Box sx={{ mb: 2, width: "100%" }}>
                        <DefaultLabel name="광고주/대행사" />
                        <OutlinedInputDefault
                          value={name.value}
                          onChange={name.onChange}
                          name={"name"}
                          krName={"광고주/대행사"}
                        />
                      </Box>
                    </Grid>
                    <Grid sx={{ width: "50%", pl: 1.25 }}>
                      <Box sx={{ mb: 2, width: "100%" }}>
                        <DefaultLabel name="담당 이메일" />
                        <OutlinedInputDefault
                          value={email.value}
                          onChange={email.onChange}
                          name={"email"}
                          krName={"담당 이메일"}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Grid sx={{ width: "50%", pr: 1.25 }}>
                      <Box sx={{ mb: 2, width: "100%" }}>
                        <DefaultLabel name="아이디" />
                        <OutlinedInputDefault
                          value={userId.value}
                          onChange={userId.onChange}
                          name={"user_id"}
                          krName={"유저 아이디"}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid container sx={{ mb: 3, mt: 3 }}>
                      <Grid sx={{ width: "50%", pr: 1.25 }}>
                        <Box sx={{ mb: 2, width: "100%" }}>
                          <DefaultLabel name="비밀번호" />
                          <OutlinedInputDefault
                            value={userPw.value}
                            onChange={userPw.onChange}
                            name={"user_pw"}
                            krName={"비밀번호"}
                            inputType={"password"}
                          />
                        </Box>
                      </Grid>
                      <Grid sx={{ width: "50%", pl: 1.25 }}>
                        <Box sx={{ mb: 2, width: "100%" }}>
                          <DefaultLabel name="비밀번호 확인" />
                          <OutlinedInputDefault
                            value={userPwConfirm.value}
                            onChange={userPwConfirm.onChange}
                            name={"user_pw_confirm"}
                            krName={"비밀번호 확인"}
                            inputType={"password"}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ mb: 8.75, mt: 8.25 }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleAdd}
                    sx={{
                      height: 56,
                      boxShadow: 0,
                      "&:hover": {
                        boxShadow: 0,
                      },
                    }}
                  >
                    <Typography variant="h3" fontWeight={500}>
                      등록
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </DefaultItem>
          </Grid>
        </Container>
      </Grid>
      <AdvertiserComplete
        open={open}
        onClick={handleCofirm}
        userId={userId.value}
        name={name.value}
        email={email.value}
      />
    </>
  );
};

export default CompAdvertiserAdd;
